(function () {
  angular.module('imnApp').controller('OltConfirmController', OltConfirmController);

  OltConfirmController.$inject = ['$scope', '$uibModalInstance', 'OltService', 'oltList', 'dataAction', 'OltData'];

  function OltConfirmController($scope, $uibModalInstance, OltService, oltList, dataAction, OltData) {
    var vm = this;
    vm.requestRunning = false;

    if (dataAction) {
      vm.action = dataAction.action;

      if (oltList.length == 1) {
        vm.oltData = oltList[0];
        vm.itemOne = true;
      } else {
        var names = '';
        var arrayNames = [];
        oltList.forEach(function (olt) {
          arrayNames.push(olt.name);
        });
        names = arrayNames.join(', ');
        vm.oltData = {
          amount: oltList.length,
          names: names
        };
        vm.itemOne = false;
      }

      vm.close = function () {
        if (!vm.requestRunning) {
          $uibModalInstance.dismiss('cancel');
        }
      };

      vm.confirmAction = function () {
        if (dataAction.confirmation) {
          vm.close();

          var postDataAction = {
            action: dataAction.afterConfirmAction,
            methodService: dataAction.methodService,
            methodExtra: dataAction.methodExtra
          };

          OltService.confirmationOltModalConstructor([OltData.detail], postDataAction);
        } else {
          vm.requestRunning = true;
          OltService[dataAction.methodService](oltList).then(success).catch(error);
        }
      };
    }

    function success(response) {
      vm.requestRunning = false;
      var isMultiple = !vm.itemOne;
      var data = null;

      if (response.status == 207) {
        OltService.warningModalConstructor(oltList, response, 'delete');
        data = response.data;
      } else {
        OltService.successModalConstructor(vm.action, isMultiple);
      }

      if (dataAction.methodExtra) {
        dataAction.methodExtra(oltList, data);
      }
    }

    function error(response) {
      vm.requestRunning = false;
      OltService.errorModalConstructor(response, vm.action);
    }
  }
})();
